'use strict';

/**
 *
 * @name: qqShare
 *
 */

function NnWechatQrCodeDirective() {

  'ngInject';

  return {
    restrict: 'AE',
    replace: true,
    template: '<span id="wechat-qr-code"></span>',
    scope: true,
    controller: function() {

      var script = document.createElement('script');

      script.onload = function() {
        /*jshint camelcase: false */
        /*jshint unused:false*/

        var obj = new WxLogin({
          id: 'wechat-qr-code',
          appid: 'wx7427963d2884fbac',
          scope: 'snsapi_login',
          // redirect_uri: encodeURIComponent(window.location.origin + '/wechat-redirect'),//微信登录bysxz
          redirect_uri: encodeURIComponent('https://www.nowness.cn/wechat-redirect'),
          state: Math.ceil(Math.random() * 1000),
          style: 'black',
          href: ''
        });
      };

      script.src = '//res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js';

      document.head.appendChild(script);
    }
  };
}

export default NnWechatQrCodeDirective;



// WEBPACK FOOTER //
// ./app/components/nn-social/nn-wechat-qr-code.directive.js